import {ApiSubstatus, type ApiSubstatusData} from "@/types/site_configuration/ApiSubstatus.ts";
import {ApiSource, type ApiSourceData} from "@/types/site_configuration/ApiSource.ts";
import {AppStatus, type AppStatusData} from "@/types/site_configuration/AppStatus";

export class ApiStatus {
    public id: number | null;
    public api_source_id: number;
    public name: string;
    public description: string;
    public apiSource: ApiSource | undefined;
    public apiSubstatuses: ApiSubstatus[];
    public appStatuses: AppStatus[];

    constructor(data: ApiStatusData | void) {
        if (data === undefined) {
            this.id = null;
            this.api_source_id = 0;
            this.name = '';
            this.description = '';
            this.apiSource = undefined;
            this.apiSubstatuses = [];
            this.appStatuses=[];

        } else {
            this.id = data.id;
            this.api_source_id = data.api_source_id;
            this.name = data.name;
            this.description = data.description;

            if (data.apiSource !== undefined && data.apiSource !== null) {
                this.apiSource = new ApiSource(data.apiSource);
            } else {
                this.apiSource = new ApiSource();
            }

            this.apiSubstatuses = [];
            if (data.apiSubstatuses !== undefined) {
                data.apiSubstatuses.forEach(apiSubstatus => this.apiSubstatuses.push((new ApiSubstatus(apiSubstatus))));
            }

            this.appStatuses = [];
            if (data.appStatuses !== undefined) {
                data.appStatuses.forEach(appStatus => this.appStatuses.push((new AppStatus(appStatus))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.api_source_id = 0;
        this.name = '';
        this.description = '';
        this.apiSource = undefined;
        this.apiSubstatuses = [];
        this.appStatuses = [];
    }

    public serializeData(without_relations: boolean | Array<string> = false): ApiSubstatusData {
        const data = {
            id: this.id,
            api_source_id: this.api_source_id,
            name: this.name,
            description: this.description,
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('apiSource')
            )
        ) {
            data.apiSource = this.apiSource.serializeData();
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('apiSubstatuses')
            )
        ) {
            data.apiSubstatuses = [];
            this.apiSubstatuses.forEach(el => {
                data.apiSubstatuses.push(el.serializeData())
            })
        }

        return data;
    }
}

export type ApiStatusData = {
    id: number | null;
    api_source_id: number;
    name: string;
    description: string;
    apiSource: ApiSourceData | undefined;
    apiSubstatuses: ApiSubstatusData[];
    appStatuses: AppStatusData[];
}

export enum ApiStatusSource {
    TMS_ROAD = 1,
    TMS_SEA,
    WMS_CROSSPOINT,
    VBS_INBOUND,
    VBS_OUTBOUND,
    TMS_AIR,
    STRONGO
}